import React, {useState, useEffect} from "react";
import { Typography,
    Grid,
    makeStyles,
    Container,
    Card,
    Button,
    useTheme,
    useMediaQuery,
    Box} from "@material-ui/core";
import { RootState } from "../../redux/store";
import { useSelector } from "react-redux";
import { colorInputBorder, colorSecondary } from "../../Constants/theme";
import {CopyToClipboard} from "react-copy-to-clipboard";
import { useSnackbar } from "notistack";
import API from "../../helpers/apiHelpers";
import Navigation from "../../Components/Navigation";

const useStyle = makeStyles(() => ({
    cardRoot: {
        width: "100%",
        padding: 40,
        marginBottom: 32,
    },
    containerRoot: {
        paddingTop: 100,
        marginBottom: 55,
        zIndex: 1,
    },
    body: {
        paddingTop: 20,
    },
    spacing: {
        paddingTop: 20,
    },
    spacingImage: {
        paddingTop: 20,
        display: "flex"
    },
}));

const Referrals = () => {
    const classes=useStyle();
    const user = useSelector((state: RootState) => state?.user);
    const [referralCode, setReferralCode] = useState("");
    const [copied, setCopied] = useState(false);
    const [amount, setAmount] = useState(0);
    const { enqueueSnackbar } = useSnackbar();
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

    useEffect(() => {
        if (copied) {
            enqueueSnackbar("Copied!", {
                autoHideDuration: 4000
            });
            setCopied(false);
        }
    }, [copied]);

    useEffect(() => {
        (async() => {
            const getCode = await API.getReferralStats();
            setReferralCode(getCode.referralCode);
            setAmount(getCode.referredSum);
        })();
    }, []);

    return(
        <Container maxWidth="md">
            <Box marginTop="115px" marginBottom="75px">
                <Grid container>
                    {!isMobile &&
                        <Grid item md={3} xs={12}>
                        	<Navigation />
                        </Grid>
                    }
                    <Grid item md={9} xs={12}>
                        <Card className={classes.cardRoot}>
                            <Container className={classes.body} disableGutters={true}>
                                <Grid container spacing={2}>
                                    <Grid item xs={12}>
                                        <Typography variant="h2" style={{fontSize: 32, paddingBottom: 25}}>
                                            Refer a friend to The Video Vets and receive $10 in appointment credit
                                        </Typography>
                                    </Grid>
                                    <Grid item xs={12}>
                                        <Typography variant="h4">
                                            Your invite code:
                                        </Typography>
                                    </Grid>
                                    <Grid item xs={3} container alignContent="center">
                                        <Typography variant="h6" style={{color: colorInputBorder}}>
                                            {referralCode}
                                        </Typography>
                                    </Grid>
                                    <Grid item xs={4} style={{marginLeft: 60}}>
                                        <CopyToClipboard
                                            text={referralCode}
                                            onCopy={() => setCopied(true)}
                                        >
                                            <Button
                                                type="button"
                                                variant="contained"
                                                color="primary"
                                                fullWidth
                                            >
                                                Copy
                                            </Button>
                                        </CopyToClipboard>
                                    </Grid>
                                    <Grid item xs={12}>
                                        <Typography variant="h4">
                                            How referrals work:
                                        </Typography>
                                    </Grid>
                                    <Grid item xs={12}>
                                        <Typography style={{color: colorInputBorder}}>
                                        Copy your unique invite code & share with your friend. During onboarding, your friend should select that he/she was referred by a friend. In doing so, your friend will be prompted to input a referral code, which will add a $10 credit that can be applied at checkout.
                                        </Typography>
                                    </Grid>
                                    <Grid item xs={12}>
                                        <Typography style={{color: colorInputBorder}}>
                                            When your friend has their first appointment, you'll earn $10 in credit.
                                        </Typography>
                                    </Grid>
                                    <Grid item xs={12}>
                                        <Typography variant="h4">
                                            You're referral credits earned:
                                        </Typography>
                                    </Grid>
                                    <Grid item xs={12}>
                                        <Typography style={{color: colorInputBorder}}>
                                            <span style={{fontSize: 28, color: colorSecondary}}>${amount}</span> available to use at checkout.
                                        </Typography>
                                    </Grid>
                                </Grid>
                            </Container>
                        </Card>
                    </Grid>
                </Grid>
            </Box>
        </Container>
    );
};

export default Referrals;
